<template>
  <div class="nav-bar-admin">
    <div class="left">
      <div class="logo">HXMT Admin</div>
      <el-dropdown class="menu-item" trigger="click" placement="bottom" @command="handleCommand">
        <div class="user-wrapper">
          <span class="user-name">审核授权</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu class="top-bar-dropdown" slot="dropdown">
          <el-dropdown-item class="logout-link" command="/admin/vav">游客申请管理
            <!-- <a class="logout-link" href="/admin/vav">游客申请审核</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/userv">用户申请管理
            <!-- <a class="logout-link" href="/admin/userv">用户申请审核</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/datauth">观测数据直接授权
            <!-- <a class="logout-link" href="/admin/datauth">数据直接授权</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/datapropauth">观测提案直接授权
            <!-- <a class="logout-link" href="/admin/datapropauth">观测提案直接授权</a> -->
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="menu-item" trigger="click" placement="bottom" @command="handleCommand">
        <div class="user-wrapper">
          <span class="user-name">数据维护</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu class="top-bar-dropdown" slot="dropdown">
          <el-dropdown-item class="logout-link" command="/admin/proposal">提案数据维护
            <!-- <a class="logout-link" href="/admin/proposal">提案数据维护</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/datarelease">数据发布
            <!-- <a class="logout-link" href="/admin/datarelease">数据发布</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/dataupgrade">数据升级包维护
            <!-- <a class="logout-link" href="/admin/datarelease">数据发布</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/grbdata">GRB数据维护
            <!-- <a class="logout-link" href="/admin/grbdata">GRB数据维护</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/semdata">SEM数据维护
            <!-- <a class="logout-link" href="/admin/semdata">SEM数据维护</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/filedata">文件数据维护
            <!-- <a class="logout-link" href="/admin/filedata">文件数据维护</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/owner">OWNER数据维护
            <!-- <a class="logout-link" href="/admin/owner">OWNER数据维护</a> -->
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>  
      <el-dropdown class="menu-item" trigger="click" placement="bottom" @command="handleCommand">
        <div class="user-wrapper">
          <span class="user-name">系统统计</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu class="top-bar-dropdown" slot="dropdown">
          <el-dropdown-item class="logout-link" command="/admin/downloadstat">数据下载记录
            <!-- <a class="logout-link" href="/admin/downloadstat">数据下载统计</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/summarystat">数据下载汇总统计
            <!-- <a class="logout-link" href="/admin/summarystat">定期汇总统计数据</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/summaryuserdata">数据下载排行统计
            <!-- <a class="logout-link" href="/admin/summarystat">定期汇总统计数据</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/summaryyearlydata">
            数据下载年度统计
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/summarypositiondata">
            数据下载指标统计
          </el-dropdown-item>
          <!-- <el-dropdown-item class="logout-link" command="/admin/summarytargettop">
            数据源下载次数TOP10
          </el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="menu-item" trigger="click" placement="bottom" @command="handleCommand">
        <div class="user-wrapper">
          <span class="user-name">系统管理</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu class="top-bar-dropdown" slot="dropdown">
          <el-dropdown-item class="logout-link" command="/admin/usermg">用户管理
            <!-- <a class="logout-link" href="/admin/usermg">用户管理</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/core">核心组维护
            <!-- <a class="logout-link" href="/admin/core">核心组维护</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/admin/syspam">系统参数维护
            <!-- <a class="logout-link" href="/admin/syspam">系统参数维护</a> -->
          </el-dropdown-item>  
          <el-dropdown-item class="logout-link" command="/admin/index">导航页面
            <!-- <a class="logout-link" href="/admin/index">导航页面</a> -->
          </el-dropdown-item>  
        </el-dropdown-menu>
      </el-dropdown>      
    </div>

    <div class="right">
      <div 
          class="menu-item"
          @click="changPage('proposal')">
          {{$t('navBar.homepage')}}
      </div>
      <el-dropdown trigger="click" v-if="userInfo" @command="handleCommand">
        <div class="user-wrapper">
          <span class="user-name">{{userInfo.truename}}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu class="top-bar-dropdown" slot="dropdown">
          <el-dropdown-item class="logout-link" command="/">{{$t('navBar.homepage')}}
            <!-- <a class="logout-link" href="/">主页</a> -->
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/iapi/logout">{{$t('navBar.logout')}}
            <!-- <a class="logout-link" href="/iapi/logout">{{$t('navBar.logout')}}</a> -->
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <a class="login-link" v-else href="/iapi/login">{{$t('navBar.login')}}</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState([
      'userInfo',
    ]),
  },
  methods: {
    changPage(name) {
      if (this.activeMenu !== name) {
        this.$router.push({name});
      }
    },
    handleCommand(param) {
      location.href = param;
    },
  },
};
</script>

<style scoped lang="scss">
.nav-bar-admin {
  background-color: #0066B8;
  box-shadow: 0px 3px 16px rgba(0,0,0,0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 56px;
}
.left, .right {
  display: flex;
  align-items: center;
}
.right {
  justify-content: right;
}
.logo {
  margin-right: 56px;
  font-size: 26px;
  color: #fff;
  font-weight: 500;
}
.logo-img {
  margin-right: 56px;
}
.menu-item {
  height: 56px;
  line-height: 56px;
  margin-right: 16px;
  border-bottom: 2px solid transparent;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  &:hover {
    border-color: #fff;
  }
}
.user-wrapper {
  font-size: 13px;
  color: #fff;
  height: 56px;
  line-height: 56px;
  cursor: pointer;
}
.login-link {
  color: #fff;
}
.logout-link {
  color: #606266;
  &:hover {
    color: #0058a3;
  }
}
</style>

<style lang="scss">
.el-dropdown-menu.top-bar-dropdown {
  padding: 6px 0;
  margin: 6px;
}
</style>
